<template>
    <div>
        <span>{{label}}</span><br>
        <v-btn @click="showModuleSelectBlock" class="py-1 my-2" small><span class="text-none caption">Добавить модуль</span></v-btn>
        <module-group-list
                :modules="modelItems"
                @updateModules="updateModules"/>
        <module-select-block
                :dialog="visModuleSelectBlock"
                :mode="1"
                @addModule="addModule"
                @close="visModuleSelectBlock = false"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ModuleGroupList from './ModuleGroupList'
import ModuleSelectBlock from '../../ModuleSelectBlock'

export default {
    name: 'ModuleVariablesIfElseSelects',
    components: {
        ModuleGroupList,
        ModuleSelectBlock
    },
    data() {
        return {
            visModuleSelectBlock: false
        }
    },
    props: ['label', 'itemsInModule', 'params', 'load', 'modelItems', 'methodId', 'index', 'indexCell'],
    computed: {
        ...mapState(['messages', 'events', 'scenarios'])
    },
    methods: {
        updateModules(value) {
            this.$emit('updateItems', { items: value, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        },
        showModuleSelectBlock() {
            this.visModuleSelectBlock = true
        },
        addModule(module) {
            let newStructure = this.modelItems.slice()
            newStructure.push(module)
            this.$emit('updateItems', { items: newStructure, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        }
    },
    created() {
        this.$store.dispatch('messages/messageAll', this.$route.params['pathMatch'])
        this.$store.dispatch('events/eventAll', this.$route.params['pathMatch'])
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
    }

}
</script>

<style scoped>
    .container {
        height: auto;
    }

    .v-text-field {
        font-size: 0.9em;
    }
</style>
